import { cn } from 'cn';

import { Icon } from '@vestigas/ui/atoms';

type P = { readonly value: boolean } & ComponentStyling;

export const BooleanValue = ({ value, className, style }: P) =>
  value ? (
    <Icon
      className={cn('text-tiga-semantic-success', className)}
      metaphor="check"
      style={style}
    />
  ) : (
    <Icon
      className={cn('text-tiga-semantic-error', className)}
      metaphor="cancel"
      style={style}
    />
  );
